import { useContext } from 'react';
import { CabinetContext, type CabinetCtx } from './CabinetContext';

export function useCabinet(): CabinetCtx {
  const v = useContext(CabinetContext);
  if (!v) throw new Error('useCabinet must be used within CabinetConfigProvider');
  return v;
}
